import { render, staticRenderFns } from "./BDatePicker.vue?vue&type=template&id=91af48e2&scoped=true&"
import script from "./BDatePicker.vue?vue&type=script&lang=js&"
export * from "./BDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91af48e2",
  null
  
)

export default component.exports